import {Col, Container, Modal, Row} from "react-bootstrap";
import {AppContext} from "../../lib/AppContext";
import React, {useContext, useEffect, useState} from "react";
import {handleDefaultValues} from "../common/Utils";
import {useForm} from 'react-hook-form';
import MDButton from "../../components/MDButton";
import MDInput from "../../components/MDInput";
import {getInventoryTypes} from "../common/api/InventoryApi";
import {NativeSelect, TextareaAutosize} from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import Grid from "@mui/material/Grid";
import {getCompanyDiscountCodeTypes, saveCompanyDiscountCode} from "../common/api/WebApi";
import TextField from "@mui/material/TextField";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import {Percent} from "@mui/icons-material";
import dayjs from "dayjs";
import {DesktopDatePicker} from "@mui/x-date-pickers";

export default function ManageDiscountCodeModal({discountCode, show, saving, handleClose, handleSave}) {

  const [context, setContext] = useContext(AppContext);

  const [perkTypes, setPerkTypes] = useState([]);
  const [discountCodeTypes, setDiscountCodeTypes] = useState([]);
  const [perkInventory, setPerkInventory] = useState(discountCode);
  const [multiple, setMultiple] = useState(discountCode?.multiple);

  const {register, handleSubmit, setValue, control} = useForm({
    values: handleDefaultValues(discountCode)
  });

  const [inventoryTypes, setInventoryTypes] = useState([]);


  const getInventoryTypesFn = () => {
    let _types = [];
    let _cafeTypes = [];
    getInventoryTypes().then(result => {
      _types = result;
      let merged = [..._cafeTypes, ...result]
      setInventoryTypes(merged);
    });
    getInventoryTypes(true).then(result => {
      _cafeTypes = result;
      let merged = [..._types, ...result]
      setInventoryTypes(merged);
    });
  }

  const [errorMessage, setErrorMessage] = useState(null);
  const saveDiscountCodeItem = (discountCode) => {
    let _d = {...discountCode};
    _d.assignedInventoryTypeIds = (_d.assignedInventoryTypeIds || []).map(Number);

    saveCompanyDiscountCode(_d).then(result => {
      handleSave(_d);
    }).catch((err) => {
      setErrorMessage(err?.response?.data?.message || 'Invalid discount code');
    });
  }

  const loadDiscountCodeTypes = () => {
    getCompanyDiscountCodeTypes().then(result => {
      setDiscountCodeTypes(result);
    });
  }

  const [discountCodeTypeId, setDiscountCodeTypeId] = useState(discountCode?.discountCodeType?.id || -1);

  const [discountAmount, setDiscountAmount] = useState();

  useEffect(() => {
    loadDiscountCodeTypes();
    getInventoryTypesFn();
  }, [])

  const [discountExpires, setDiscountExpires] = useState(discountCode?.discountExpires);

  return (
    <Modal onHide={handleClose} size={'lg'} show={show}>
      <form
        onSubmit={handleSubmit(saveDiscountCodeItem)} id={'memberForm'}>
        <Modal.Header closeButton>
          <Modal.Title>{discountCode?.guid ? 'Edit' : 'Create'} Discount</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col className={'col col-main'} xs={12}>
              <Container>
                <Row>
                  <Col className={'col'} sm={12} xs={12}>
                    <div className="form-group">
                      <MDInput
                        required
                        variant="outlined" type="text"
                        {...register('name')}
                        placeholder="Enter Discount Title"
                        autoComplete="off"
                        InputLabelProps={{shrink: true}}
                        className="form-control" id="name"
                        label="Discount Title"/>

                    </div>
                  </Col>

                </Row>
                <Row>
                  <Col sm={6} xs={12}>

                    {discountCodeTypes?.length > 0 && <>
                      <div className="form-group native-margin-fix">
                        <label htmlFor={"discountCodeType"} className={"native-label mt-4"}>Discount Type</label>
                        <NativeSelect
                          autoComplete="off"
                          variant="outlined"
                          required
                          id={'discountCodeType'} name={'discountCodeType'} className={'form-control'}
                          {...register('discountCodeType.id', {
                            required: true,
                            onChange: (e) => {
                              setDiscountCodeTypeId(parseInt(e.target.value, 10))
                            },
                            validate: (value) => value > 0 || 'Please select a valid option',
                          })}>
                          <option value={-1}>Choose</option>
                          {
                            discountCodeTypes.map((c) =>
                              <option value={c.id} key={c.id}>
                                {c.name}
                              </option>)
                          }
                        </NativeSelect>

                      </div>
                    </>
                    }

                  </Col>

                  <Col sm={6} xs={12}>
                    <div className="form-group mt-4">
                      <MDInput
                        required={!multiple}
                        maxLength={55}
                        variant="outlined" type="text"
                        {...register('code', {
                          maxLength: 55,
                          onChange: ((e) => {
                            setErrorMessage(e.target?.value?.length > 16 ? 'Max Code Length is 55 characters' : null)
                          })
                        })}
                        disabled={multiple}
                        placeholder="Enter Code"
                        autoComplete="off"
                        InputLabelProps={{shrink: true}}
                        className="form-control" id="code"
                        label="Discount Code"/>
                      {errorMessage && <p><small>{errorMessage}</small></p>}
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col sm={6} xs={12}>
                    <div className="form-group mt-4">
                      <p className={'m-0'}><label>
                        <Checkbox defaultChecked={discountCode?.multiple}
                                  {...register('multiple', {
                                    onChange:(e)=>{
                                      if (e.target.checked) {
                                        setValue('code', '');
                                        setMultiple(true);
                                      } else {
                                        setMultiple(false);
                                      }
                                    }
                                  })} /> Add Multiple</label></p>
                    </div>
                  </Col>
                  <Col sm={6} xs={12}>
                    <div className="form-group mt-4">
                      {multiple &&
                        <TextareaAutosize
                          {...register('codeTokens')}
                          autoComplete="off"
                          minRows={3}
                          className="form-control" id="desc"
                          placeholder={'Enter Custom Codes (Single-Use)'} />
                      }
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col xs={12} sm={6}>
                    <div className="form-group mt-4">
                      <p className={'m-0'}><label>
                        <Checkbox defaultChecked={discountCode?.unlimited}
                                  {...register('unlimited', {})} /> Unlimited use?</label></p>
                    </div>
                  </Col>
                  <Col xs={12} sm={6}>
                    <div className="form-group mt-4">
                      <p className={'m-0'}><label>
                        <Checkbox defaultChecked={discountCode?.discountExpires}
                                  {...register('discountExpires', {
                                    onChange: ((e) => {
                                      setDiscountExpires(e.target.checked)
                                    })
                                  })} /> Discount Code Expires?</label></p>
                    </div>
                  </Col>

                </Row>

                <Row>
                  <Col xs={12} sm={6}>
                    <TextField type="text" step="1" required
                               min={1}
                               {...register("value", {
                                 required: true,
                                 valueAsDouble: true
                               })}
                               max={discountCodeTypeId === 2 ? 100 : 100000}
                               InputProps={{
                                 onChange: (e) => {
                                   let v = e.target.value.replace(/[^0-9.]/g, '');
                                   setValue('value', v)
                                 },
                                 disabled: !discountCodeTypeId,
                                 startAdornment: discountCodeTypeId === 1 ? <AttachMoneyIcon/> : <></>,
                                 endAdornment: discountCodeTypeId === 2 ? <Percent/> : <></>,
                                 inputProps: {min: 0, max: (discountCodeTypeId === 2 ? 100 : 100000), step: 0.1}
                               }}
                               disabled={!discountCodeTypeId}
                               autoComplete="off"
                               name="amount"
                               placeholder={"Discount Amount"}
                               className="form-control pull-left mt-4" id="value"
                               label="Discount Amount"
                               style={{width: '250px'}}/>
                  </Col>
                  <Col xs={12} sm={6}>
                    <div className="form-group mt-4">
                      <>
                        <DesktopDatePicker
                          {...register('expirationDate', {
                            disabled: !discountExpires
                          })}
                          slotProps={{
                            actionBar: {
                              actions: ['today'],
                            },
                          }}
                          value={!discountCode?.expirationDate ? null : dayjs(discountCode.expirationDate)}
                          onChange={(e) => {
                            if (!e?.$d) {
                              setValue('expirationDate', null)
                            } else {
                              setValue('expirationDate', new Date(e.$d))
                            }
                          }}
                        />
                      </>
                    </div>
                  </Col>

                </Row>

                <Row>
                  <Col xs={12}>
                    <div className="form-group mt-4">
                      <p><b>Discounted Inventory Types</b></p>
                      <Grid container>
                        {
                          inventoryTypes?.sort((a, b) => a.sortOrder - b.sortOrder).map((c) =>
                            <Grid item xs={12} sm={6} key={c.id}>
                              <label>
                                <Checkbox
                                  defaultChecked={discountCode?.assignedInventoryTypeIds?.indexOf(c.id) > -1}
                                  {...register('assignedInventoryTypeIds[]', {})}
                                  value={parseInt(c.id, 10)} key={c.id}/>
                                {c.name}
                              </label>
                            </Grid>
                          )
                        }
                      </Grid>
                    </div>
                  </Col>
                </Row>

              </Container>
            </Col>
          </Row>

        </Modal.Body>
        <Modal.Footer>
          <MDButton type="submit" color="info" disabled={saving}>
            {saving ? 'Saving...' : 'Save'}
          </MDButton>
        </Modal.Footer>
      </form>
    </Modal>
  );
}